







export default {
  name: 'Button'
};
